import { render, staticRenderFns } from "./WhySwitch.vue?vue&type=template&id=40d8560c&scoped=true&"
import script from "./WhySwitch.vue?vue&type=script&lang=js&"
export * from "./WhySwitch.vue?vue&type=script&lang=js&"
import style0 from "./WhySwitch.vue?vue&type=style&index=0&id=40d8560c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d8560c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
